var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableHead",
    { staticClass: "reports-listing-table-head" },
    _vm._l(_vm.columns, function(column) {
      return _c(
        "CompassTableHeadCell",
        {
          key: column.code,
          attrs: {
            sortable: column.sortable,
            alignContent: column.alignContent
          },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("sort-table-head", { orderBy: column.code })
            }
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-bold" }, [
            _vm._v("\n            " + _vm._s(column.label) + "\n        ")
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }